export const formatPhoneNumber = (phone) => {
  if (phone) {
    let number = phone.replace(/\D/g, '').replace(/\s/g, '');
    let formattedNumber = '';

    if (number.substring(0, 1) === '1') {
      number = number.substring(1);
    }
    if (number.length > 0) {
      formattedNumber += `(${number.substring(0, 3)}`;
    }
    if (number.length > 3) {
      formattedNumber += `) ${number.substring(3, 6)}`;
    }
    if (number.length > 6) {
      formattedNumber += `-${number.substring(6, 10)}`;
    }

    return formattedNumber;
  }
  return '';
};

export const formatCurrency = (currency) => {
  function reverse(str) {
    return str.split('').reverse().join('');
  }

  if (!currency) {
    return '';
  }

  const numbers = currency.split('.');
  let dollars = numbers[0].replace(/\D/g, '');
  let cents = numbers[1];

  if (cents) {
    cents = cents.slice(0, 2);
  }

  if (dollars.length > 4) {
    dollars = reverse(reverse(dollars).match(/.{1,3}/g).join(','));
  }

  if (typeof cents === 'string') {
    return `$ ${dollars}.${cents.slice(0.2)}`;
  }

  return `$ ${dollars}`;
};

export const cleanCurrency = (currency) => {
  if (!currency) {
    return '';
  }

  const numbers = currency.split('.');
  let cents = numbers[1];

  if (typeof cents === 'string' && cents.length > 0 && parseInt(cents, 10) > 0) {
    while (cents.length < 2) {
      cents += '0';
    }

    return `${numbers[0]}.${cents}`;
  }

  return numbers[0];
};

export const formatNumber = (string) => {
  if (string) {
    return string.replace(/\D/g, '');
  }
  return '';
};
